import { render } from "./VoiceDictationButton.vue?vue&type=template&id=4f88dd18"
import script from "./VoiceDictationButton.vue?vue&type=script&lang=js"
export * from "./VoiceDictationButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__